import { Injectable } from '@angular/core';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { GenericResponse } from '../../../../Autofacets-Core/src/app/business-entities/generic-response.class';
import { Urls } from '../../../../Autofacets-Core/src/app/utils/urls';
import { UserShiftRequestModel } from '../business-entities/user-opening-view-model';

@Injectable({
  providedIn: 'root'
})
export class UserDataWorkingHourService {

  constructor(private dataProvider: DataService) { }

  addEditSpecialOccasion(occasionalShiftSaveViewModel: any) {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.UserAddEditSpecialOccasion, occasionalShiftSaveViewModel).toPromise();
  }

  getSpecialOccasionList(receptionUserId: any) {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.UserSpecialOccasionList, receptionUserId).toPromise();
  }

  getUserWorkingHoursDetails(receptionUserId: string, occasionId: number): Promise<GenericResponse<any>> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetUserWorkingHours, receptionUserId, occasionId).toPromise();
  }

  updateUserWorkingHours(userWorkingHours: UserShiftRequestModel): Promise<GenericResponse<any>> {
    return this.dataProvider.Put<GenericResponse<boolean>>(Urls.UpdateUserWorkingHours, userWorkingHours).toPromise();
  }

  getUserLunchShiftDetails(userId: string): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetUserLunchShiftDetails, userId).toPromise();
  }

  deleteSpecialOccasion(occasionalShiftDeleteViewModel: any) {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.UserDeleteSpecialOccasion, occasionalShiftDeleteViewModel).toPromise();
  }

  addUserLeaves(userLeaves: any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.AddUserLeaves, userLeaves).toPromise();
  }

  getUserLeaves(leaveId: number, userLeaveRecurringId: number): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetUserleaveById, leaveId, (userLeaveRecurringId) ? userLeaveRecurringId : 0).toPromise();
  }

  getUserLeavesList(receptionUserId: string): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetUserLeaveList, receptionUserId).toPromise();
  }

  updateUserLeave(userLeaves: any): Promise<GenericResponse<any>> {
    return this.dataProvider.Put<GenericResponse<any>>(Urls.UpdateUserLeaves, userLeaves).toPromise();
  }

  deleteLeave(leaveId: number): Promise<any> {
    return this.dataProvider.Delete<GenericResponse<any>>(Urls.DeleteUserLeave, leaveId).toPromise();
  }
}
